import { PaletteMode } from '@mui/material';
import { chronoDefinedDarkTokens, chronoDefinedLightTokens } from '@/theme/unityTokens';
import { GetThemeOptions } from '../../theme';
import { ChronosphereColorPalette, green } from '../colors';

export const primaryColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? chronoDefinedLightTokens : chronoDefinedDarkTokens;
    return {
      main: tokens['--primary-color-main'],
      highContrast: tokens['--primary-color-high-contrast'],
      lowContrast: tokens['--primary-color-low-contrast'],
    };
  }

  return mode === 'light'
    ? {
        main: green[600],
        highContrast: green[800],
        lowContrast: green[150],
      }
    : {
        main: green[500],
        highContrast: green[300],
        lowContrast: green[700],
      };
};
